<a id="skipcontent"
  class="skip-to-content"
  [tabindex]="tabIndex"
  (click)="onAnchorClick($event)"
  [title]="title">
    {{ title }}
</a>